import { gql } from '@apollo/client'

const PRE_WIZARD_GUEST_ITERABLE_UPSERT_WITH_RECAPTCHA_MUTATION = gql`
  mutation PreWizardGuestIterableUpsertWithRecaptchaMutation(
    $email: String!
    $recaptchaToken: String!
  ) {
    preWizardGuestIterableUpsertWithRecaptcha(
      email: $email
      recaptchaToken: $recaptchaToken
    ) {
      trackingId
    }
  }
`

export { PRE_WIZARD_GUEST_ITERABLE_UPSERT_WITH_RECAPTCHA_MUTATION }
